import { Alert, Button, Checkbox, Col, Form, Input, InputNumber, Modal, Row, Select, Table } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState } from 'react';
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    CloseOutlined,
    UploadOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { currencyFormat } from '../../Utils/formatCurrency';
import * as XLSX from 'xlsx';

function ProductClearance() {
    const token = useSelector((state) => state.user.token);
    const [form] = Form.useForm();
    const importInputRef = useRef(null);

    const [data, setData] = useState([]);
    const [outlet, setOutlet] = useState([]);
    const [product, setProduct] = useState([]);
    const [variant, setVariant] = useState([]);

    const [outletValue, setOutletValue] = useState([]);
    const [dayValue, setDayValue] = useState([]);
    const [productValue, setProductValue] = useState(null);
    const [variantValue, setVariantValue] = useState(null);
    const [priceValue, setPriceValue] = useState(null);
    const [dataProduct, setDataProduct] = useState([]);

    const [searchProductTable, setSearchProductTable] = useState('');
    const [productPage, setProductPage] = useState({
        current: 1,
        pageSize: 5,
    });

    const [loading, setLoading] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [importLoading, setImportLoading] = useState(false);

    const [search, setSearch] = useState('');
    const [load, setLoad] = useState(0);

    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const titlePage = 'Product Clearance';

    const templateUrl = '/assets/TEMPLATE_CLEARANCE.xlsx';

    const dayOptions = [
        { value: 'senin', label: 'Senin' },
        { value: 'selasa', label: 'Selasa' },
        { value: 'rabu', label: 'Rabu' },
        { value: 'kamis', label: 'Kamis' },
        { value: 'jumat', label: "Jum'at" },
        { value: 'sabtu', label: 'Sabtu' },
        { value: 'minggu', label: 'Minggu' },
    ];

    const getProductItemKey = (item) => {
        const variantId = item?.variant_product_id;
        return `${item?.product_id || 'product'}-${variantId ?? 'no-variant'}`;
    };

    const filteredDataProduct = dataProduct.filter((item) => {
        const keyword = searchProductTable.toLowerCase();

        return (
            item.product_name?.toLowerCase().includes(keyword) ||
            item.variant_name?.toLowerCase().includes(keyword) ||
            item.SKU?.toLowerCase().includes(keyword) ||
            item.product_code?.toLowerCase().includes(keyword)
        );
    });

    const columns = [
        {
            title: 'No',
            render: (id, record, index) => {
                return (page.pagination.current - 1) * page.pagination.pageSize + index + 1;
            },
        },
        {
            title: 'Judul',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Deskripsi',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Tanggal Mulai',
            dataIndex: 'start_date',
            key: 'start_date',
        },
        {
            title: 'Tanggal Selesai',
            dataIndex: 'end_date',
            key: 'end_date',
        },
        {
            title: 'Jam Mulai',
            dataIndex: 'start_time',
            key: 'start_time',
        },
        {
            title: 'Jam Selesai',
            dataIndex: 'end_time',
            key: 'end_time',
        },
        {
            title: 'Hari',
            key: 'days',
            render: (text, record) => {
                if (!record.clearance_days || record.clearance_days.length === 0) {
                    return '-';
                }

                return record.clearance_days
                    .map((item) => {
                        const found = dayOptions.find((day) => day.value === item.day);
                        return found ? found.label : item.day;
                    })
                    .join(', ');
            },
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            render: (text) => text === true ? 'Aktif' : 'Tidak Aktif',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                            <b style={{ marginLeft: 5 }}>Ubah</b>
                        </Button>
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                            <b style={{ marginLeft: 5 }}>Hapus</b>
                        </Button>
                    </>
                );
            },
        },
    ];

    const columnsProduct = [
        {
            title: 'No',
            render: (text, record, index) => {
                return (productPage.current - 1) * productPage.pageSize + index + 1;
            },
        },
        {
            title: 'Kode Produk',
            key: 'product_code',
            render: (text, record) => record.product_code || '-',
        },
        {
            title: 'Nama Produk',
            dataIndex: 'product_name',
            key: 'product_name',
        },
        {
            title: 'Nama Varian',
            dataIndex: 'variant_name',
            key: 'variant_name',
            render: (text, record) => text || record.variant_name || '-',
        },
        {
            title: 'Harga Clearance',
            dataIndex: 'price',
            key: 'price',
            render: (text) => Number(text) >= 0 ? currencyFormat(text) : '-',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button type="text" danger onClick={() => deleteProduct(record)}>
                        <CloseOutlined />
                    </Button>
                );
            },
        },
    ];

    useEffect(() => {
        getApi('GET', '/clearance?search=' + search + '&page=' + page.pagination.current, 'all');

        if (outlet.length === 0) {
            getApi('GET', '/outlet?nopage=true', 'outlet');
        }

        if (product.length === 0) {
            getApi('GET', '/selectproduct', 'product');
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [load]);

    const getApi = (method, url, type, dataReqBody = null) => {
        setIsAlert(false);
        setLoading(true);

        const dataReq = {
            method,
            url,
            data: {
                data: dataReqBody,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        };

        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'all':
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data,
                            },
                        });
                        setLoading(false);
                        break;

                    case 'outlet': {
                        const rowOutlet = res.data.map((item) => ({
                            value: item.outlet_id,
                            label: item.outlet_name,
                        }));

                        setOutlet(rowOutlet);
                        setLoading(false);
                        break;
                    }

                    case 'product': {
                        const rowProduct = res.data.rows.map((item) => ({
                            value: JSON.stringify(item),
                            label: item.product_name,
                        }));

                        setProduct(rowProduct);
                        setLoading(false);
                        break;
                    }

                    case 'insert':
                    case 'update':
                    case 'delete':
                        setIsAlert(true);
                        setTextAlert(res.message);
                        setLoad(load + 1);
                        setLoading(false);
                        setLoadingBtn(false);
                        closeModal();
                        break;

                    default:
                        setLoading(false);
                        setLoadingBtn(false);
                        break;
                }
            } else {
                setLoading(false);
                setLoadingBtn(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            setLoadingBtn(false);
            console.log(e.message);
        });
    };

    const normalizeText = (value) => {
        return String(value || '').trim();
    };

    const normalizeHeader = (value) => {
        return String(value || '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    };

    const normalizePrice = (value) => {
        if (value === null || value === undefined || value === '') return null;

        const cleaned = String(value)
            .replace(/rp/gi, '')
            .replace(/\./g, '')
            .replace(/,/g, '')
            .replace(/\s/g, '')
            .trim();

        const numberValue = Number(cleaned);

        return Number.isNaN(numberValue) ? null : numberValue;
    };

    const getRowValue = (row, aliases) => {
        const keys = Object.keys(row);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (aliases.includes(normalizeHeader(key))) {
                return row[key];
            }
        }

        return '';
    };

    const findProductByCode = (kodeProduk) => {
        const code = normalizeText(kodeProduk);

        for (let i = 0; i < product.length; i++) {
            const prod = JSON.parse(product[i].value);

            if (normalizeText(prod.product_code) === code) {
                const defaultVariant =
                    prod.variant_products && prod.variant_products.length > 0
                        ? prod.variant_products[0]
                        : null;

                return {
                    product: prod,
                    variant: defaultVariant,
                    matchType: 'PRODUCT_CODE',
                };
            }

            if (prod.variant_products && prod.variant_products.length > 0) {
                const foundVariant = prod.variant_products.find(
                    (variantItem) => normalizeText(variantItem.SKU) === code
                );

                if (foundVariant) {
                    return {
                        product: prod,
                        variant: foundVariant,
                        matchType: 'SKU',
                    };
                }
            }
        }

        return null;
    };

    const showImportPopup = () => {
        Modal.confirm({
            title: 'Import Produk Clearance',
            width: 620,
            okText: 'Pilih File Excel',
            cancelText: 'Batal',
            icon: <UploadOutlined />,
            content: (
                <div>
                    <p style={{ marginBottom: 8 }}>
                        Upload file Excel sesuai template Produk Clearance.
                    </p>

                    <div
                        style={{
                            background: '#fafafa',
                            border: '1px solid #f0f0f0',
                            borderRadius: 8,
                            padding: 12,
                            marginBottom: 12,
                        }}
                    >
                        <b>Format kolom wajib:</b>
                        <div style={{ marginTop: 6 }}>
                            <code>Kode Produk</code> | <code>Nama Produk</code> | <code>Harga</code>
                        </div>
                    </div>

                    <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                        <li>Kode Produk akan dicocokkan dengan Product Code atau SKU.</li>
                        <li>Harga tidak boleh kosong, minus, atau bukan angka.</li>
                        <li>Produk yang sudah ada di tabel akan dilewati otomatis.</li>
                    </ul>
                </div>
            ),
            onOk: () => {
                if (product.length === 0) {
                    modalError('Data produk belum tersedia. Tunggu sebentar lalu coba lagi.');
                    return Promise.reject();
                }

                importInputRef.current?.click();

                return Promise.resolve();
            },
        });
    };

    const showDownloadTemplatePopup = () => {
        Modal.confirm({
            title: 'Download Template Excel',
            width: 560,
            okText: 'Download Template',
            cancelText: 'Batal',
            icon: <DownloadOutlined />,
            content: (
                <div>
                    <p style={{ marginBottom: 8 }}>
                        Download template Excel untuk import Produk Clearance.
                    </p>

                    <div
                        style={{
                            background: '#fafafa',
                            border: '1px solid #f0f0f0',
                            borderRadius: 8,
                            padding: 12,
                        }}
                    >
                        Lokasi file:
                        <br />
                        <code>{templateUrl}</code>
                    </div>
                </div>
            ),
            onOk: () => {
                const link = document.createElement('a');
                link.href = templateUrl;
                link.download = 'TEMPLATE_CLEARANCE.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
        });
    };

    const handleImportExcel = (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const allowedTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
        ];

        const fileExtension = file.name.split('.').pop()?.toLowerCase();

        if (!allowedTypes.includes(file.type) && !['xlsx', 'xls'].includes(fileExtension)) {
            modalError('File harus berformat .xlsx atau .xls');
            e.target.value = '';
            return;
        }

        setImportLoading(true);

        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const workbook = XLSX.read(evt.target.result, {
                    type: 'binary',
                });

                const sheetName = workbook.SheetNames[0];

                if (!sheetName) {
                    modalError('Sheet Excel tidak ditemukan');
                    setImportLoading(false);
                    e.target.value = '';
                    return;
                }

                const worksheet = workbook.Sheets[sheetName];

                const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                    defval: '',
                });

                if (jsonData.length === 0) {
                    modalError('File Excel kosong');
                    setImportLoading(false);
                    e.target.value = '';
                    return;
                }

                const importedProducts = [];
                const skippedRows = [];

                jsonData.forEach((row, index) => {
                    const rowNumber = index + 2;

                    const kodeProduk = getRowValue(row, [
                        'kode produk',
                        'kode_produk',
                        'product code',
                        'product_code',
                        'sku',
                    ]);

                    const hargaValue = getRowValue(row, [
                        'harga',
                        'harga clearance',
                        'harga_clearance',
                        'price',
                    ]);

                    const kodeProdukClean = normalizeText(kodeProduk);
                    const hargaClean = normalizePrice(hargaValue);

                    if (!kodeProdukClean) {
                        skippedRows.push({
                            row: rowNumber,
                            reason: 'Kode Produk kosong',
                        });
                        return;
                    }

                    if (hargaClean === null || hargaClean < 0) {
                        skippedRows.push({
                            row: rowNumber,
                            reason: 'Harga tidak valid',
                        });
                        return;
                    }

                    const found = findProductByCode(kodeProdukClean);

                    if (!found || !found.product) {
                        skippedRows.push({
                            row: rowNumber,
                            reason: `Produk / SKU "${kodeProdukClean}" tidak ditemukan`,
                        });
                        return;
                    }

                    const candidate = {
                        product_id: found.product.product_id,
                        variant_product_id: found.variant?.variant_product_id ?? null,
                    };

                    const isDuplicateCurrent = dataProduct.some(
                        (item) => getProductItemKey(item) === getProductItemKey(candidate)
                    );

                    const isDuplicateImport = importedProducts.some(
                        (item) => getProductItemKey(item) === getProductItemKey(candidate)
                    );

                    if (isDuplicateCurrent || isDuplicateImport) {
                        skippedRows.push({
                            row: rowNumber,
                            reason: `Produk / SKU "${kodeProdukClean}" duplikat`,
                        });
                        return;
                    }

                    importedProducts.push({
                        product_id: found.product.product_id,
                        product_code: found.product.product_code,
                        product_name: found.product.product_name,
                        variant_product_id: found.variant?.variant_product_id ?? null,
                        variant_name: found.variant?.variant_name || 'Tanpa Varian',
                        SKU: found.variant?.SKU || '-',
                        price: hargaClean,
                    });
                });

                if (importedProducts.length > 0) {
                    setDataProduct((prev) => [...importedProducts, ...prev]);
                    setProductPage({
                        ...productPage,
                        current: 1,
                    });
                }

                Modal.success({
                    title: 'Import Excel Selesai',
                    width: 650,
                    content: (
                        <div>
                            <p style={{ marginBottom: 8 }}>
                                <b>{importedProducts.length}</b> produk berhasil ditambahkan.
                            </p>

                            <p style={{ marginBottom: 8 }}>
                                <b>{skippedRows.length}</b> baris dilewati.
                            </p>

                            {skippedRows.length > 0 && (
                                <div
                                    style={{
                                        maxHeight: 220,
                                        overflowY: 'auto',
                                        background: '#fafafa',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: 8,
                                        padding: 10,
                                    }}
                                >
                                    {skippedRows.slice(0, 30).map((item, idx) => (
                                        <div key={idx}>
                                            Baris {item.row}: {item.reason}
                                        </div>
                                    ))}

                                    {skippedRows.length > 30 && (
                                        <div style={{ marginTop: 8 }}>
                                            Dan {skippedRows.length - 30} baris lainnya.
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ),
                });
            } catch (err) {
                console.log(err);

                modalError('Format file Excel tidak valid');
            }

            setImportLoading(false);
            e.target.value = '';
        };

        reader.onerror = () => {
            modalError('Gagal membaca file Excel');
            setImportLoading(false);
            e.target.value = '';
        };

        reader.readAsBinaryString(file);
    };

    const selectData = (event, type) => {
        const json_arr = JSON.parse(event);

        if (type === 'product') {
            setProductValue(JSON.stringify(json_arr));

            const rowVariant = [];

            if (json_arr.variant_products && json_arr.variant_products.length > 0) {
                for (let i = 0; i < json_arr.variant_products.length; i++) {
                    rowVariant.push({
                        value: JSON.stringify(json_arr.variant_products[i]),
                        label: json_arr.variant_products[i].variant_name !== null
                            ? json_arr.variant_products[i].variant_name
                            : json_arr.variant_products[i].SKU,
                    });
                }

                setVariant(rowVariant);
                setVariantValue(null);
            } else {
                const noVariant = {
                    variant_product_id: null,
                    variant_name: 'Tanpa Varian',
                    SKU: null,
                };

                const noVariantValue = JSON.stringify(noVariant);
                setVariant([{ value: noVariantValue, label: 'Tanpa Varian' }]);
                setVariantValue(noVariantValue);
            }
        } else {
            setVariantValue(JSON.stringify(json_arr));
        }
    };

    const saveProduct = () => {
        if (productValue == null) {
            modalError('Produk kosong');
            return;
        }

        if (variantValue == null) {
            modalError('Varian kosong');
            return;
        }

        if (priceValue == null || Number(priceValue) < 0) {
            modalError('Harga clearance tidak boleh kosong / minus');
            return;
        }

        const prod = JSON.parse(productValue);
        const vari = JSON.parse(variantValue);

        const candidate = {
            product_id: prod.product_id,
            variant_product_id: vari.variant_product_id ?? null,
        };

        const duplicate = dataProduct.find(
            item => getProductItemKey(item) === getProductItemKey(candidate)
        );

        if (duplicate) {
            modalError('Produk ini sudah ditambahkan');
            return;
        }

        const row = {
            product_id: prod.product_id,
            product_code: prod.product_code,
            product_name: prod.product_name,
            variant_product_id: vari.variant_product_id ?? null,
            variant_name: vari.variant_name || 'Tanpa Varian',
            SKU: vari.SKU || '-',
            price: Number(priceValue),
        };

        setDataProduct(prev => [row, ...prev]);
        setProductValue(null);
        setVariantValue(null);
        setPriceValue(null);
        setVariant([]);
        setProductPage({
            ...productPage,
            current: 1,
        });
    };

    const deleteProduct = (record) => {
        const row = dataProduct.filter(
            item => getProductItemKey(item) !== getProductItemKey(record)
        );

        setDataProduct(row);
        setProductPage({
            ...productPage,
            current: 1,
        });
    };

    const resetProductTable = () => {
        setSearchProductTable('');
        setProductPage({
            current: 1,
            pageSize: 5,
        });
    };

    const openModal = (type, data) => {
        resetProductTable();

        if (type === 'edit') {
            setDataModal(data);

            const ev = {
                title: data.title,
                description: data.description,
                start_date: data.start_date,
                end_date: data.end_date,
                start_time: data.start_time,
                end_time: data.end_time,
                is_active: data.is_active,
            };

            if (data.clearance_outlets && data.clearance_outlets.length > 0) {
                const rowOutlet = data.clearance_outlets.map((o) => o.outlet_id);
                setOutletValue(rowOutlet);
                ev.outlets = rowOutlet;
            } else {
                setOutletValue([]);
                ev.outlets = [];
            }

            if (data.clearance_days && data.clearance_days.length > 0) {
                const rowDays = data.clearance_days.map((d) => d.day);
                setDayValue(rowDays);
                ev.days = rowDays;
            } else {
                setDayValue([]);
                ev.days = [];
            }

            if (data.clearance_items && data.clearance_items.length > 0) {
                const rowProduct = [];

                for (let i = 0; i < data.clearance_items.length; i++) {
                    const item = data.clearance_items[i];

                    rowProduct.push({
                        product_id: item.product_id,
                        product_code: item.product?.product_code,
                        product_name: item.product?.product_name,
                        variant_product_id: item.variant_product_id,
                        variant_name: item.variant_product?.variant_name || 'Tanpa Varian',
                        SKU: item.variant_product?.SKU || '-',
                        price: item.price,
                    });
                }

                setDataProduct(rowProduct);
            } else {
                setDataProduct([]);
            }

            setProductValue(null);
            setVariantValue(null);
            setPriceValue(null);
            setVariant([]);

            form.setFieldsValue(ev);
            setIsModal(true);
        } else {
            setDataModal(null);
            setOutletValue([]);
            setDayValue([]);
            setProductValue(null);
            setVariantValue(null);
            setPriceValue(null);
            setVariant([]);
            setDataProduct([]);
            form.resetFields();
            form.setFieldsValue({
                is_active: true,
                outlets: [],
                days: [],
            });
            setIsModal(true);
        }
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Anda ingin menghapus data ini?',
            onOk: () => getApi('DELETE', '/clearance/' + v.clearance_product_id, 'delete'),
        });
    };

    const onFinish = (ev) => {
        if (outletValue.length === 0) {
            modalError('Outlet kosong');
            return;
        }

        if (dayValue.length === 0) {
            modalError('Hari kosong');
            return;
        }

        if (dataProduct.length === 0) {
            modalError('Produk clearance kosong');
            return;
        }

        setLoadingBtn(true);

        const payload = {
            title: ev.title,
            description: ev.description,
            start_date: ev.start_date,
            end_date: ev.end_date,
            start_time: ev.start_time,
            end_time: ev.end_time,
            is_active: ev.is_active,

            days: dayValue,

            outlets: outletValue.map((id) => ({
                outlet_id: id,
            })),

            items: dataProduct.map((item) => ({
                product_id: item.product_id,
                variant_product_id: item.variant_product_id,
                price: item.price,
            })),
        };

        if (dataModal !== null) {
            payload.clearance_product_id = dataModal.clearance_product_id;

            getApi(
                'PUT',
                '/clearance/' + dataModal.clearance_product_id,
                'update',
                payload
            );
        } else {
            getApi('POST', '/clearance', 'insert', payload);
        }
    };

    const closeModal = () => {
        setDataModal(null);
        setIsModal(false);
        setOutletValue([]);
        setDayValue([]);
        setProductValue(null);
        setVariantValue(null);
        setPriceValue(null);
        setVariant([]);
        setDataProduct([]);
        resetProductTable();
        form.resetFields();
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        setLoad(load + 1);
    };

    const handleTableChange = (pagination) => {
        setPage({
            pagination,
        });
        setLoad(load + 1);

        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <div className="page-heading">
                <div>
                    <div className="page-eyebrow">PROMOTION</div>
                    <h2>Product Clearance</h2>
                    <p>Atur produk, outlet, periode, dan harga clearance dari satu tempat.</p>
                </div>
            </div>

            <Row gutter={[12, 12]} className="clearance-toolbar page-toolbar">
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Search
                        placeholder="Cari clearance..."
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>

                <Col xs={24} sm={12} md={16} lg={18} className="clearance-toolbar-actions" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        disabled={loadingBtn}
                        style={{ marginBottom: 10 }}
                        type="primary"
                        onClick={() => openModal('add', null)}
                    >
                        <PlusOutlined />
                        <span>Tambah Clearance</span>
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                rowKey="clearance_product_id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={page.pagination}
                onChange={handleTableChange}
                scroll={{ x: 'max-content' }}
            />

            <Modal
                title={dataModal ? "Edit Product Clearance" : "Tambah Product Clearance"}
                open={isModal}
                onOk={form.submit}
                onCancel={() => closeModal()}
                okText="Simpan"
                width={1000}
                styles={{ body: { overflowX: 'hidden' } }}
                confirmLoading={loadingBtn}
            >
                <Form
                    form={form}
                    name="form_product_clearance"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="title"
                        label="Judul"
                        rules={[{ required: true, message: 'Judul harus diisi!' }]}
                    >
                        <Input placeholder="Masukkan judul" />
                    </Form.Item>

                    <Form.Item name="description" label="Deskripsi">
                        <Input.TextArea rows={3} placeholder="Masukkan deskripsi" />
                    </Form.Item>

                    <Form.Item name="outlets" label="Pilih Outlet">
                        <Select
                            virtual={false}
                            mode="multiple"
                            showSearch
                            placeholder="Pilih Outlet"
                            optionFilterProp="label"
                            options={outlet}
                            value={outletValue}
                            onChange={(ev) => {
                                setOutletValue(ev);
                                form.setFieldsValue({ outlets: ev });
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Form.Item name="days" label="Pilih Hari">
                        <Select
                            virtual={false}
                            mode="multiple"
                            showSearch
                            placeholder="Pilih Hari"
                            optionFilterProp="label"
                            options={dayOptions}
                            value={dayValue}
                            onChange={(ev) => {
                                setDayValue(ev);
                                form.setFieldsValue({ days: ev });
                            }}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Row style={{ marginBottom: 8, alignItems: 'center' }}>
                        <Col xs={24} md={12}>
                            <div
                                style={{
                                    display: 'flex',
                                    gap: 8,
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                }}
                            >
                                <p
                                    style={{
                                        marginBottom: 0,
                                        fontWeight: 600,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: 24,
                                        marginTop: -3,
                                    }}
                                >
                                    Produk Clearance
                                </p>


                                <Button
                                    size="small"
                                    type="primary"
                                    ghost
                                    icon={<UploadOutlined />}
                                    loading={importLoading}
                                    onClick={showImportPopup}
                                >
                                    Import Excel
                                </Button>

                                <Button
                                    size="small"
                                    icon={<DownloadOutlined />}
                                    onClick={showDownloadTemplatePopup}
                                >
                                    Template
                                </Button>

                                <input
                                    ref={importInputRef}
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleImportExcel}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </Col>

                        <Col xs={24} md={12}>
                            <Search
                                placeholder="Cari produk / varian / SKU"
                                allowClear
                                size="medium"
                                value={searchProductTable}
                                onSearch={(value) => {
                                    setSearchProductTable(value);
                                    setProductPage({
                                        ...productPage,
                                        current: 1,
                                    });
                                }}
                                onChange={(e) => {
                                    setSearchProductTable(e.target.value);
                                    setProductPage({
                                        ...productPage,
                                        current: 1,
                                    });
                                }}
                            />
                        </Col>
                    </Row>

                    <Row gutter={[8, 8]}>
                        <Col xs={24} sm={12} md={8}>
                            <Select
                            virtual={false}
                                showSearch
                                placeholder="Pilih Produk"
                                optionFilterProp="label"
                                options={product}
                                value={productValue}
                                onChange={(ev) => selectData(ev, 'product')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col xs={24} sm={12} md={8}>
                            <Select
                            virtual={false}
                                showSearch
                                placeholder="Pilih Varian"
                                optionFilterProp="label"
                                options={variant}
                                value={variantValue}
                                onChange={(ev) => selectData(ev, 'variant')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col xs={18} sm={18} md={5}>
                            <InputNumber
                                placeholder="Harga Clearance"
                                value={priceValue}
                                min={0}
                                onChange={(value) => setPriceValue(value)}
                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                style={{ width: '100%' }}
                            />
                        </Col>

                        <Col xs={6} sm={6} md={3}>
                            <Button block type="primary" onClick={() => saveProduct()}>
                                <PlusOutlined />
                            </Button>
                        </Col>
                    </Row>

                    <Table
                        style={{ marginTop: 10, marginBottom: 10 }}
                        size="small"
                        rowKey={(record) => getProductItemKey(record)}
                        columns={columnsProduct}
                        dataSource={filteredDataProduct}
                        scroll={{ x: 'max-content' }}
                        pagination={{
                            current: productPage.current,
                            pageSize: productPage.pageSize,
                            total: filteredDataProduct.length,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20', '50'],
                            onChange: (current, pageSize) => {
                                setProductPage({
                                    current,
                                    pageSize,
                                });
                            },
                        }}
                    />

                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item name="start_date" label="Tanggal Mulai">
                                <Input type="date" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item name="end_date" label="Tanggal Selesai">
                                <Input type="date" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col xs={24} md={12}>
                            <Form.Item name="start_time" label="Jam Mulai">
                                <Input type="time" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item name="end_time" label="Jam Selesai">
                                <Input type="time" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item name="is_active" label="Status" valuePropName="checked">
                        <Checkbox>Aktif</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default ProductClearance;